import { updateDiagramSaveFilteredOnly} from '@process-advisor/process-miner/processMiner/processMiner';

export type SaveFilteredOnlyProps = {
    filteredOnly?: boolean;
}

export const saveFilteredOnly = ({
    filteredOnly,
}: SaveFilteredOnlyProps) => updateDiagramSaveFilteredOnly({
    filteredOnly,
});


